/**
 * Преобразует русскую дату в формате "24 февраля 2025 в 15:00" в объект Date
 * @param {string} russianDate - Дата в русском формате
 * @returns {Date} - Объект Date
 */
function parseRussianDate(russianDate) {
    // Русские названия месяцев
    const monthsDict = {
        января: 0,
        февраля: 1,
        марта: 2,
        апреля: 3,
        мая: 4,
        июня: 5,
        июля: 6,
        августа: 7,
        сентября: 8,
        октября: 9,
        ноября: 10,
        декабря: 11,
    };

    // Разбираем строку даты регуляркой
    const parts = russianDate.match(
        /^(\d{1,2})\s+(января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря)\s+(\d{4})\s+в\s+(\d{1,2}):(\d{2})\s+(МСК)$/
    );
    if (!parts) {
        console.warn('Неверный формат даты приёма заявок');
        return;
    }

    const [, day, month, year, hours, minutes] = parts;
    const monthIndex = monthsDict[month.toLowerCase()];

    if (monthIndex === undefined) {
        console.warn('Неверное название месяца');
        return;
    }

    return new Date(year, monthIndex, day, hours, minutes);
}

/**
 * Проверяет, наступила ли дата из элемента с классом due-date
 * @returns {Object} - Результат проверки
 */
function checkDateFromElement() {
    // Элемент с датой
    const dateElement = document.querySelector('.due-date');

    if (!dateElement) {
        console.warn('Элемент с классом due-date не найден');
        return;
    }

    const russianDate = dateElement.textContent.trim();
    const targetDate = parseRussianDate(russianDate);
    const now = new Date();

    // Сравниваем даты
    const isReached = now >= targetDate;

    return { isReached };
}

// HTML: <div class="due-date">24 февраля 2025 в 15:00</div>
document.addEventListener('DOMContentLoaded', function () {
    const result = checkDateFromElement();
    const textBtn = document.querySelector('.text-btn');

    if (textBtn) {
        result.isReached
            ? (textBtn.textContent = 'Информация о торгах')
            : (textBtn.innerHTML = 'Участвовать в&nbsp;торгах');
    }
});
